<template>
  <section class="content">
    <table class="table table-hover" ref="tableorigin">
      <thead>
        <tr>
          <th>Kurir</th>
          <th>Kode</th>
          <th>Nama</th>
          <th>Extended</th>
        </tr>
      </thead>
      <tbody @click="handleClick"></tbody>
    </table>
    <div
      class="modal"
      tabindex="-1"
      role="dialog"
      ref="formDialog"
      data-backdrop="static"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <form role="form" @submit="submitForm">
            <div class="modal-header">
              <h5 class="modal-title">{{ formTitle }}</h5>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <p v-if="errors.length" class="alert alert-danger">
                <b>Please correct the following error(s):</b>
              </p>
              <div class="col-md-6 form-group">
                <label class="control-label">Kurir</label>
                <select
                  v-model="form.courier_id"
                  id="courier_id"
                  name="courier_id"
                  class="form-control"
                >
                  <option
                    v-for="courier in groups"
                    v-bind:key="courier.courier_id"
                    v-bind:value="courier.courier_id"
                  >
                    {{ courier.label }}
                  </option>
                </select>
              </div>
              <div class="col-md-6 form-group">
                <label class="control-label">Kode</label>
                <input type="hidden" name="row_id" value="" />
                <input
                  id="kode"
                  class="form-control"
                  v-model="form.kode"
                  type="text"
                  required="required"
                  name="kode"
                />
              </div>
              <div class="col-md-6 form-group">
                <label class="control-label">Nama</label>
                <input type="hidden" name="row_id" value="" />
                <input
                  id="nama"
                  class="form-control"
                  v-model="form.nama"
                  type="text"
                  name="nama"
                />
              </div>
            </div>
            <div class="modal-footer">
              <button type="submit" class="btn btn-primary">
                Save changes
              </button>
              <button
                type="button"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                Close
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
  <!-- /.content -->
</template>
<script>
import { createTable, authFetch } from "@/libs/hxcore";
import Swal from "sweetalert2";
import $ from "jquery";

export default {
  name: "Data List Origin",
  data() {
    return {
      errors: [],
      method: "",
      roles: "",
      groups: [],
      formTitle: "Tambah List Origin",
      form: {
        courier_id: "",
        kode: "",
        nama: "",
      },
    };
  },
  created: function () {
    this.roles = this.$route.meta.roles;
    console.log("load initial data", this.$route);

    //get data courier for dropdown select
    authFetch("/shipper/kurir")
      .then((res) => {
        if (res.status === 201) {
        } else if (res.status === 400) {
        }
        return res.json();
      })
      .then((js) => {
        this.groups = js.data;
      });
  },
  methods: {
    handleClick(e) {
      if (e.target.matches(".link-role")) {
        this.$router.push({ path: "/permit/" + e.target.dataset.id });
        return false;
      }
    },
    submitForm: function (ev) {
      const e = this.$refs;
      var data = Object.keys(this.form)
        .map(
          (key) =>
            encodeURIComponent(key) + "=" + encodeURIComponent(this.form[key])
        )
        .join("&");
      var urlSubmit = "/master/origin";
      if (this.method == "PUT") urlSubmit = "/master/origin/" + this.form.id;

      authFetch(urlSubmit, {
        method: this.method,
        body: data,
      })
        .then((res) => {
          if (res.status === 201) {
          } else if (res.status === 400) {
          }
          return res.json();
        })
        .then((js) => {
          this.errors = [];
          if (!js.success) {
            console.log(js.details);

            for (var key in js.details) {
              if (js.details.hasOwnProperty(key)) {
                this.errors.push(js.details[key]);
              }
            }

            return;
          }
          this.table.api().ajax.reload();
          $(e.formDialog).modal("hide");
        });

      ev.preventDefault();
    },
  },
  mounted() {
    const e = this.$refs;
    var self = this;
    this.table = createTable(e.tableorigin, {
      title: "Data List Origin",
      roles: this.$route.params.roles,
      ajax: "/master/origin",
      processing: true,
      language: {
        processing: '<i class="fa fa-spinner fa-5x fa-spin" style="font-size:50px;color:black;"></i>'},
      columns: [
        { data: "kurir" },
        { data: "kode" },
        { data: "nama" },
        { data: "extended" },
      ],
      filterBy: [0, 1, 2],
      rowCallback: function (row, data) {
        if (data.extended == 0)
          $("td:eq(3)", row).html(
            '<h5 class="text-center"><i class="fa fa-check"></i></h5>'
          );
        else $("td:eq(3)", row).html("");
      },
      buttonClick: (evt) => {
        if (evt.role == "create") {
          self.form = {};
          self.method = "POST";
          self.errors = [];
          self.formTitle = "Tambah List Origin";
          $(e.formDialog).modal("show");
        } else if (evt.role == "update" && evt.data) {
          self.form = evt.data;
          self.method = "PUT";
          self.errors = [];
          self.formTitle = "Edit List Origin";
          $(e.formDialog).modal("show");
        } else if (evt.role == "delete" && evt.data) {
          console.log(evt);
          Swal.fire({
            title: "Hapus data?",
            icon: "question",
            denyButtonText: '<i class="fa fa-times"></i> Hapus',
            showCancelButton: true,
            showDenyButton: true,
            showConfirmButton: false,
          }).then((result) => {
            if (result.isDenied) {
              authFetch("/master/origin/" + evt.data.id, {
                method: "DELETE",
                body: "id=" + evt.data.id,
              })
                .then((res) => {
                  return res.json();
                })
                .then((js) => {
                  this.table.api().ajax.reload();
                });
            }
          });
        }
      },
    });
  },
};
</script>